import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

export default styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  marginTop: 10,
  marginBottom: 10,
  textTransform: 'unset',
  minWidth: 200,
  color: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}))
